import { render, staticRenderFns } from "./ClientStatusEditDetails.vue?vue&type=template&id=3e68bb9a&scoped=true&"
import script from "./ClientStatusEditDetails.vue?vue&type=script&lang=js&"
export * from "./ClientStatusEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e68bb9a",
  null
  
)

export default component.exports